export default __webpack_public_path__ + "static/media/HomepagePlayCard.c4378037.png";